import React, {useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {MapContainer, Marker, TileLayer, useMap} from 'react-leaflet'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Icon} from 'leaflet'
import "./DeviceOnMap.scss"
const MapResizeHandler = () => {
  const map = useMap()
  useEffect(() => {
    map.invalidateSize()
  }, [map])
  return null
}

const DeviceOnMap: React.FC<any> = ({location, show, setShow, setLocation}) => {
  const pin = toAbsoluteUrl('/media/svg/iFleetcam/ifleetcam_logo_icon.png')

  const handleClose = () => {

    setShow(false)
    setLocation(null)
  }

  return (
    <>
      {show ? (
        <Modal show={show} onHide={handleClose} centered>
         <div className="device-map-close">
            <button className='btn btn-link p-0 ' type='button' onClick={handleClose}>
              <i
                className='fa fa-times-thin fa-2x cursor-pointer'
                aria-hidden='true'
                style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
              ></i>
            </button>
          </div>
          <Modal.Body>
            <div style={{height: '46vh'}}>
              <MapContainer
                center={[location.Lat, location.Long]}
                zoom={13}
                style={{width: '100%', height: '100%', zIndex: 1}}
              >
                <TileLayer
                  attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Marker
                  position={[location.Lat, location.Long]}
                  icon={
                    new Icon({
                      iconUrl: pin,
                      iconSize: [40, 50],
                    })
                  }
                />
                <MapResizeHandler />
              </MapContainer>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <></>
      )}
    </>
  )
}

export default DeviceOnMap
